<div class="flex flex-col gap-5">
    @if (screeningAi.isDrafting()) {
    <div aria-busy="true" class="flex flex-col gap-5">
        <bb-ai-thoughts-scroll [thoughts]="screeningAi.streamingThoughts()"
            [isCompiling]="screeningAi.isCompilingBrief()" />
    </div>
    } @else {

    @if (showMethodChooser()) {
    <div class="flex flex-col gap-3.5">
        <p class="m-0 text-lg font-bold tracking-tight text-foreground">How do you want to define what to screen for?</p>
        <ul role="list" class="grid grid-cols-1 gap-3 sm:grid-cols-3">
            @for (m of methods; track m.id) {
            <li>
                <button type="button" (click)="selectMethod(m.id)"
                    [attr.aria-pressed]="createScreeningService.creativeMethod() === m.id"
                    class="relative flex w-full flex-col items-start gap-1 rounded-lg border p-4 text-left transition-colors"
                    [class]="createScreeningService.creativeMethod() === m.id ? 'border-brand-studio bg-brand-studio/10' : 'border-border bg-card hover:border-brand-studio/60'">
                    @if (m.tag) {
                    <span
                        class="absolute right-3 top-3 rounded-full bg-brand-studio px-2 py-0.5 text-[10px] font-extrabold tracking-wider text-white">{{
                        m.tag }}</span>
                    }
                    <span class="mb-1 grid size-10 place-items-center rounded-md transition-colors"
                        [class]="createScreeningService.creativeMethod() === m.id ? 'bg-brand-studio text-white' : 'bg-muted text-muted-foreground'">
                        @switch (m.id) {
                        @case ('upload') {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 13v8" />
                            <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
                            <path d="m8 17 4-4 4 4" />
                        </svg>
                        }
                        @case ('type') {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 20h9" />
                            <path
                                d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z" />
                        </svg>
                        }
                        @case ('ai') {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                        </svg>
                        }
                        }
                    </span>
                    <span class="text-base font-bold text-foreground">{{ m.title }}</span>
                    <span class="text-xs leading-relaxed text-muted-foreground">{{ m.desc }}</span>
                </button>
            </li>
            }
        </ul>
    </div>

    @if (showMethodChooser() && createScreeningService.creativeMethod() === 'upload') {
    <div class="flex flex-col gap-2">
        <atom-add-document (documentUploaded)="onDocumentUploaded($event)" />
        <p class="m-0 text-xs text-muted-foreground">We store your document with the brief so the team can reference it
            —
            you can still fill in the details below.</p>
    </div>
    } @else if (showMethodChooser() && createScreeningService.creativeMethod() === 'ai') {

    <div class="flex flex-col gap-4">
        <div class="flex gap-3.5 rounded-lg border border-brand-studio bg-brand-studio/10 p-5">
            <span class="grid size-10 shrink-0 place-items-center rounded-full bg-brand-studio text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path
                        d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                </svg>
            </span>
            <div>
                <h2 class="m-0 font-heading text-lg font-bold text-foreground">Let SHOUT AI draft your screening brief
                </h2>
                <p class="m-0 mt-1 text-sm leading-relaxed text-muted-foreground">Describe what to look for in creators'
                    past content. SHOUT AI drafts the overview, requirements, and red flags — you review and refine
                    after.</p>
            </div>
        </div>

        <bb-field label="Anything to steer it?"
            hint="Optional — leave blank and SHOUT AI works from your product and brand.">
            <textarea [value]="prompt()" (input)="prompt.set($any($event.target).value)" rows="3"
                placeholder="e.g. Find creators who have authentically posted about sustainable skincare, with no paid competitor promotions…"
                class="w-full resize-y rounded-md border border-border bg-card px-3 py-2 text-sm outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25"></textarea>
        </bb-field>

        <div>
            <p class="m-0 mb-2 text-xs font-medium text-muted-foreground">Try an example</p>
            <div class="flex flex-wrap gap-2">
                @for (example of examples; track example.name) {
                <button type="button" (click)="prompt.set(example.prompt)"
                    class="inline-flex items-center rounded-full px-3 py-1.5 text-xs font-medium bg-primary/10 text-accent ring-1 ring-inset ring-primary/15 hover:bg-primary/15 transition-colors cursor-pointer">{{
                    example.name }} — {{ example.description }}</button>
                }
            </div>
        </div>

        <button type="button" (click)="draftWithAi()" [disabled]="screeningAi.isDrafting()"
            class="inline-flex items-center gap-2 self-start rounded-md bg-brand-studio px-4 py-2.5 text-sm font-bold text-white transition-colors hover:bg-brand-studio-dark disabled:opacity-50">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                    d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
            </svg>
            Draft with SHOUT AI
        </button>

        @if (screeningAi.draftError()) {
        <p class="m-0 text-sm text-destructive" role="alert">{{ screeningAi.draftError() }}</p>
        }
    </div>

    } @else {
    <bb-field label="Screening Overview"
        [hint]="overviewHint">
        <atom-wysiswyg [inputHtml]="createScreeningService.briefTextHtml()"
            (htmlContentChange)="onHtmlContentChange($event, 'briefText')"
            [placeholder]="overviewPlaceholder"></atom-wysiswyg>
    </bb-field>

        <!-- @if (createScreeningService.requirementsHtml() || createScreeningService.restrictionsHtml() || !showMethodChooser()) { -->
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <ng-container [ngTemplateOutlet]="screeningCriteriaEditors"></ng-container>
        </div>
        <!-- } -->

    <div class="sm:col-span-full bg-transparent">
        <label for="screen-content-from" class="block text-md font-semibold text-foreground/80">Look back as far as</label>
        <p class="text-xs text-secondary">{{ lookbackHint }}</p>
        <mat-form-field class="w-full event-date-field mt-2 bg-transparent">
            <input matInput [matDatepicker]="picker" [max]="today"
                [value]="createScreeningService.screenContentUntil() ?? null"
                id="screen-content-from" class="event-date-input text-primary" readonly>
            <mat-hint class="text-secondary">e.g. 12 May 2026</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker [dateClass]="dateClass" #picker [startAt]="today"
                (selectedChange)="onDateChange($event)"></mat-datepicker>
        </mat-form-field>
    </div>
    }
    } @else {
        <bb-field label="Screening Overview"
            [hint]="overviewHint">
            <atom-wysiswyg [inputHtml]="createScreeningService.briefTextHtml()"
                (htmlContentChange)="onHtmlContentChange($event, 'briefText')"
                [placeholder]="overviewPlaceholder"></atom-wysiswyg>
        </bb-field>

        @if (createScreeningService.requirementsHtml() || createScreeningService.restrictionsHtml() || !showMethodChooser()) {
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <ng-container [ngTemplateOutlet]="screeningCriteriaEditors"></ng-container>
        </div>
    }
    }
    }
</div>

<!-- Editable screening criteria (requirements + red flags), shared across the wizard AI mode and the AI-first flow. -->
<ng-template #screeningCriteriaEditors>
    <bb-field label="What content must show" [labelIconHtml]="checkIcon"
        hint="The signals a creator's past content must demonstrate to pass screening.">
        <bb-edit-list [items]="requirements()" [placeholder]="requirementPlaceholder" addLabel="Add a requirement"
            (itemsChange)="setRequirements($event)" />
    </bb-field>
    <bb-field label="Red flags &amp; disqualifiers" [labelIconHtml]="crossIcon"
        hint="Content signals that should fail screening.">
        <bb-edit-list [items]="donts()" [placeholder]="redFlagPlaceholder" addLabel="Add a red flag"
            (itemsChange)="setDonts($event)" />
    </bb-field>
</ng-template>